import type { State } from '../types';
import uniq from 'lodash/uniq';
import first from 'lodash/first';
import { OperationType } from '../../types';
import { truthy } from '../../utils';

export function getDefaultBillingProfile({ state }: { state: State }) {
  const selectedProducts = Object.keys(state.selectedProducts);
  const selectedBillingProfiles = uniq(
    selectedProducts
      .map((productId) => {
        if (state.products[productId].operationType !== OperationType.TRANSFER) {
          return state.products[productId].sourceInvoiceGroupId;
        }
      })
      .filter(truthy)
  );

  const defaultBillingProfile = first(selectedBillingProfiles);
  return selectedBillingProfiles?.length === 1 && defaultBillingProfile ? defaultBillingProfile : '';
}
